import React, { useContext, useState, useEffect } from "react";
import { motion } from "framer-motion";
import Footer from "../components/Footer/Footer";
import SkillPage from "../components/Skill/SkillPage";
import OfficeTitle from "../components/Three/OfficeTitle";
import LoadingHome from "../components/Loading/LoadingHome";
import { Context } from "../context";

const Skill = () => {
  const { debug, lang } = useContext(Context);
  const [text, setText] = useState("");
  const [text2, setText2] = useState("");

  useEffect(() => {
    if (lang === "en") {
      setText("Skills");
      setText2("Major development skills");
    } else if (lang === "it") {
      setText("Skills");
      setText2("Principali skills");
    }
  }, [lang]);

  return (
    <>
      <title>Davide Balice - Skills</title>
      <LoadingHome />
      <motion.main
        initial={{ opacity: 0.6, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0.6 }}
        transition={{ duration: 0.4, delay: 1 }}
      >
        <OfficeTitle text={text} text2={text2} />
        <SkillPage />
        <Footer />
      </motion.main>
    </>
  );
};

export default Skill;
